import React, { useState } from "react";
import TableResult from "./component/tableResult";
import { Spin } from "antd";

export default function BarangPage(){
    const [loadingSpin, setLoadingSpin] = useState(false)
    return(
        <div className="fitur-all">
            <Spin spinning={loadingSpin} tip="Processing Resi...">
                <TableResult setLoadingSpin={setLoadingSpin} />
            </Spin>
        </div>
    )
}